import { ColumnDescription } from "react-bootstrap-table-next";
import Table from "../../../../../Components/Table";
import OrSpinner from "../../../../../Components/Utils/OrSpinner";
import { useModuloInfo } from "../../../../../Context/ModuloInfo";
import {
    DeletaEtapaCategoriaAtendimentoTipoCasoGrupoController,
    ListarCategoriaAtendimentoTipoCasoController,
} from "../../../../../Controllers/Repasse/EtapasCasoRepasse/InsereEtapaCategoriaAtendimentoTipoCasoGrupoControllers";
import useAsyncCallback from "../../../../../hooks/useAsyncCallback";
import useAsyncEffect from "../../../../../hooks/useAsyncEffect";
import { IEtapaPorGrupo } from "../../../../../Interfaces/Geral/Etapas/EtapasInterfaces";

interface IEtapasVinculadasGrupoProps {
    idGrupo: number;
    idCategoriaAtendimento: number;
}

export default function EtapasVinculadasGrupo(
    props: IEtapasVinculadasGrupoProps
) {
    const { id } = useModuloInfo();

    const {
        execute: updateTipoCaso,
        value: categoriaTipoCaso,
        loading: categoriaTipoCasoLoading,
    } = useAsyncEffect(
        () =>
            ListarCategoriaAtendimentoTipoCasoController(
                id ?? 5,
                props.idGrupo,
                props.idCategoriaAtendimento
            ),
        [props, id]
    );
    const {
        execute: DeleteEtapaCategoria,
        loading: DeleteEtapaCategoriaLoading,
    } = useAsyncCallback(
        DeletaEtapaCategoriaAtendimentoTipoCasoGrupoController
    );

    const columns: Array<ColumnDescription<IEtapaPorGrupo>> = [
        {
            dataField: "DS_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO",
            text: "Etapa",
        },
        {
            dataField: "NR_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO",
            text: "N° da Etapa",
        },
        {
            dataField: "FL_ETAPA_INICIAL",
            text: "Etapa Inicial",
            formatter: (_, row: IEtapaPorGrupo) => {
                return (
                    <div className="d-flex justify-content-center align-itens-center ">
                        {row.FL_ETAPA_INICIAL ? (
                            <p className="p-2 font-weight-bold">Sim</p>
                        ) : (
                            <p className="p-2 font-weight-bold">Não</p>
                        )}
                    </div>
                );
            },
        },
        {
            dataField: "FL_ETAPA_FINAL",
            text: "Etapa Final",

            formatter: (_, row: IEtapaPorGrupo) => {
                return (
                    <div className="d-flex justify-content-center align-itens-center ">
                        {row.FL_ETAPA_FINAL ? (
                            <p className="p-2 font-weight-bold">Sim</p>
                        ) : (
                            <p className="p-2 font-weight-bold">Não</p>
                        )}
                    </div>
                );
            },
        },
        {
            dataField: "DS_GRUPO",
            text: "Desvincular Etapa",
            isDummyField: true,

            formatter: (_, row) => (
                <div className="Button-Tools d-flex justify-content-center align-items-center">
                    <button
                        className="btn btn-outline-danger font-weight-bold mr-2"
                        onClick={() => {
                            DeleteEtapaCategoria(
                                row.ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO_GRUPO
                            ).then(updateTipoCaso);
                        }}
                        disabled={DeleteEtapaCategoriaLoading}
                    >
                        <span className="d-none d-sm-block">Desvincular</span>
                    </button>
                </div>
            ),
        },
    ];

    return (
        <OrSpinner loading={categoriaTipoCasoLoading} spinner="capys">
            <Table
                data={categoriaTipoCaso ?? []}
                columns={columns}
                keyField="ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO"
                noDataIndication={
                    <div className="text-center text-muted">Nenhuma etapa</div>
                }
                loading={categoriaTipoCasoLoading}
                wrapperClasses="wrapperTable mw-100 x-scroll"
                noSearch
                classes="tableClasses"
                bordered={false}
                center
                defaultStyle={{
                    align: "center",
                    classes: "p-2",
                }}
            />
        </OrSpinner>
    );
}
